export default __webpack_public_path__ + "beta-maps-guides-migrate-3d-terrain-960-bfefda510065546c53e09a5bf6358423.webp";